import React, {Component} from 'react';
import {isPostVisible} from '../../../../shared/utils/FeedHelpers';
import AggregateFeedListItem from './AggregateFeedListItem';
import styles from './Feed.module.css';

export default class AggregateFeedList extends Component {
  render() {
    const {
      userFeed,
      eventID,
      type,
      origin,
      mergeNewPost,
      pinnedPost,
      updatePostLike,
      updatePostComment,
    } = this.props;
    return (
      <div className={styles.aggregateFeedContainter}>
        {userFeed.length > 0 && userFeed.map(
          (singleFeed, i) =>
            isPostVisible(pinnedPost, singleFeed) && (
              <AggregateFeedListItem
                data={{...singleFeed, ...singleFeed.activities[0]}}
                type={type}
                eventID={eventID}
                key={i}
                origin={origin}
                mergeNewPost={mergeNewPost}
                updatePostLike={updatePostLike}
                updatePostComment={updatePostComment}
              />
            ),
        )}
      </div>
    );
  }
}
